import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Select } from '@pwc/pwc-deals-ui';
import { getLibraryItems } from '../libraryItemService';
import './LibraryItemSelect.scss';

const LibraryItemSelect = ({ field }) => {
  const [libraryItems, setLibraryItems] = useState([]);
  const { projectId } = useParams();

  useEffect(() => {
    let isMounted = true;
    const fetch = async () => {
      const response = await getLibraryItems(projectId);
      if (response && isMounted) setLibraryItems(response);
    };
    fetch();

    return () => {
      isMounted = false;
    };
  }, [projectId]);

  const groups = [
    { type: 300, label: 'Charts' },
    { type: 301, label: 'NamedRanges' },
  ];

  const options = groups.map((group) =>
    libraryItems
      .filter((item) => item.type === group.type)
      .map((item) => ({ type: item.type, value: item.id, label: item.name }))
  );
  const flattenedOptions = [].concat(...options);

  return (
    <Select
      className="library-item-select"
      selectTestId="library-item-select"
      label="Library Item"
      name={field.name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      optiongroup={groups}
      options={flattenedOptions}
      placeholder="Please select a Library Item"
      value={field.value}
    />
  );
};

export default LibraryItemSelect;
